<!--deprecated component, will be removed in the future-->
<template>
  <breadcrumbs-component :breadCrumbs="breadCrumbs" />
  <div class="w-screen max-w-[1160px]">
    <WeeklyReport />
    <SatisfactionReport v-if="getMoodomatEnabled" />
    <CollaborationTrend v-if="getKSSEnabled" />
    <Omindset />
  </div>
  <ProvideFeedbackComponent></ProvideFeedbackComponent>
</template>

<script>
import BreadcrumbsComponent from '@/components/Home/Shared/BreadcrumbsComponent.vue';
import WeeklyReport from './WeeklyReportComponent/WeeklyReportComponent.vue';
import SatisfactionReport from './SatisfactionReportComponent/SatisfactionReportComponent.vue';
import CollaborationTrend from './CollaborationTrendComponent/CollaborationTrendComponent.vue';
import Omindset from './OmindsetComponent/OmindsetComponent.vue';
import ProvideFeedbackComponent from '@/components/global/ProvideFeedbackComponent.vue';

export default {
  name: 'ManagementDashboardComponent',
  components: {
    BreadcrumbsComponent,
    WeeklyReport,
    SatisfactionReport,
    CollaborationTrend,
    Omindset,
    ProvideFeedbackComponent,
  },
  data() {
    return {
      breadCrumbs: [
        {
          route: '/management-dashboard',
          isActive: true,
          label: this.$t('BreadCrumbs.mngDashboard'),
        },
      ],
    };
  },
  computed: {
    getMoodomatEnabled() {
      return import.meta.env.VITE_MOODOMAT === 'true';
    },
    getKSSEnabled() {
      return import.meta.env.VITE_KSS === 'true';
    },
  },
  methods: {},
};
</script>
